/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WorkerProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get a worker token
   * @returns any Success
   * @throws ApiError
   */
  public getApiServicesecurityProcessesWorkersToken(): CancelablePromise<{
    token?: string;
    workerUrl?: string;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/workers/{workerUuid}/token',
    });
  }

}
